import { decodePeriodValue, getPeriodButtonLabel } from '@components'

import { TFunction } from 'i18next'

import { sanitizeFileName } from '../../../../../utils/export/sanitizeFileName'

export const getFileName = (organizationName: string, period: string, t: TFunction) => {
  const decodedPeriod = decodePeriodValue(period)

  return `${sanitizeFileName(organizationName)}-${sanitizeFileName(getPeriodButtonLabel(t, decodedPeriod))}.csv`
}
